
import React from 'react';
import { cn } from '@/lib/utils';
import * as LucideIcons from 'lucide-react';
import './SettingsToggle.css';

interface SettingsToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
  icon?: string;
  disabled?: boolean;
  className?: string;
}

const SettingsToggle: React.FC<SettingsToggleProps> = ({
  checked,
  onChange,
  label,
  description,
  icon,
  disabled = false,
  className
}) => {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  // Get the icon component if specified
  const IconComponent = icon && icon in LucideIcons 
    ? LucideIcons[icon as keyof typeof LucideIcons] as React.ComponentType<{ className?: string }>
    : null;

  return (
    <div className={cn('settings-toggle', disabled && 'settings-toggle-disabled', className)}>
      <div className="settings-toggle-content">
        <div className="settings-toggle-header">
          {IconComponent && <IconComponent className="settings-toggle-icon" />}
          <label htmlFor={label} className="settings-toggle-label">
            {label}
          </label>
        </div>
        {description && (
          <p className="settings-toggle-description">{description}</p>
        )}
      </div>
      <button
        id={label}
        type="button"
        role="switch"
        aria-checked={checked}
        aria-labelledby={`${label}-label`}
        className={cn(
          'settings-toggle-switch',
          checked && 'settings-toggle-switch-checked',
          disabled && 'settings-toggle-switch-disabled'
        )}
        onClick={handleToggle}
        disabled={disabled}
      >
        <div className="settings-toggle-track">
          <div className="settings-toggle-thumb" />
        </div>
      </button>
    </div>
  );
};

export default SettingsToggle;
